import { Descriptions, Tag } from 'antd';
import { formatDate } from '../../utils/dateHelpers';
import {
  FORM_STATUS_LABELS,
  FORM_STATUS_COLORS,
  getMoodEmoji,
  labelsFromKeys,
  PROUD_RESULTS,
  WENT_WELL,
  DIFFICULTIES,
  HELPS_EFFECTIVE,
  HINDERS_WORK,
  COLLEAGUE_DIFFICULTIES,
  COLLEAGUE_ISSUES,
  PROCESSES_TO_IMPROVE,
  RECENT_LEARNING,
  DEVELOPMENT_SUPPORT,
  DISCUSSION_TOPICS,
  FEEDBACK_NEEDED,
  MANAGER_FEEDBACK,
  MEETING_MAIN_RESULT,
} from '../../utils/validation';

const renderMulti = (keys, map, otherText) => {
  const text = labelsFromKeys(keys, map);
  return otherText ? `${text}${text ? '; ' : ''}${otherText}` : text || '—';
};

const FormResponseView = ({ form }) => (
  <Descriptions column={1} bordered size="small">
    <Descriptions.Item label="Статус">
      <Tag color={FORM_STATUS_COLORS[form.status]}>{FORM_STATUS_LABELS[form.status]}</Tag>
    </Descriptions.Item>
    <Descriptions.Item label="Дата заполнения">{formatDate(form.fillDate)}</Descriptions.Item>
    <Descriptions.Item label="Общее настроение">
      {getMoodEmoji(form.moodScore)} {form.moodScore}/10
      {form.moodComment && ` — ${form.moodComment}`}
    </Descriptions.Item>
    <Descriptions.Item label="Оценка двух недель">
      {form.twoWeeksScore}/10
      {form.twoWeeksComment && ` — ${form.twoWeeksComment}`}
    </Descriptions.Item>
    <Descriptions.Item label="Уровень нагрузки">{form.workloadLevel}/10</Descriptions.Item>
    <Descriptions.Item label="Уровень стресса">{form.stressLevel}/10</Descriptions.Item>
    <Descriptions.Item label="Удовлетворённость своей работой">
      {form.jobSatisfaction}/10
    </Descriptions.Item>
    <Descriptions.Item label="Удовлетворённость работой команды">
      {form.teamSatisfaction}/10
    </Descriptions.Item>
    <Descriptions.Item label="Состояние">
      <Tag>{form.stateWord}</Tag>
    </Descriptions.Item>
    <Descriptions.Item label="Гордость за результаты">
      {renderMulti(form.proudResults, PROUD_RESULTS)}
    </Descriptions.Item>
    <Descriptions.Item label="Получилось хорошо">
      {renderMulti(form.wentWell, WENT_WELL, form.wentWellOther)}
    </Descriptions.Item>
    <Descriptions.Item label="Трудности">
      {renderMulti(form.difficulties, DIFFICULTIES, form.difficultiesOther)}
    </Descriptions.Item>
    <Descriptions.Item label="Помогает работать">
      {renderMulti(form.helpsEffective, HELPS_EFFECTIVE, form.helpsEffectiveOther)}
    </Descriptions.Item>
    <Descriptions.Item label="Мешает работе">
      {renderMulti(form.hindersWork, HINDERS_WORK, form.hindersWorkOther)}
    </Descriptions.Item>
    <Descriptions.Item label="Сложности с коллегами">
      {COLLEAGUE_DIFFICULTIES[form.colleagueDifficulties] || '—'}
    </Descriptions.Item>
    {form.colleagueDifficulties !== 'no' && (
      <Descriptions.Item label="С чем связаны">
        {renderMulti(form.colleagueIssues, COLLEAGUE_ISSUES, form.colleagueIssuesOther)}
      </Descriptions.Item>
    )}
    <Descriptions.Item label="Процессы для улучшения">
      {renderMulti(form.processesToImprove, PROCESSES_TO_IMPROVE, form.processesToImproveOther)}
    </Descriptions.Item>
    <Descriptions.Item label="Новые знания">
      {renderMulti(form.recentLearning, RECENT_LEARNING, form.recentLearningOther)}
    </Descriptions.Item>
    <Descriptions.Item label="Поддержка для развития">
      {renderMulti(form.developmentSupport, DEVELOPMENT_SUPPORT, form.developmentSupportOther)}
    </Descriptions.Item>
    <Descriptions.Item label="Темы для обсуждения">
      {renderMulti(form.discussionTopics, DISCUSSION_TOPICS, form.discussionTopicsOther)}
    </Descriptions.Item>
    <Descriptions.Item label="Нужна обратная связь">
      {renderMulti(form.feedbackNeeded, FEEDBACK_NEEDED, form.feedbackNeededOther)}
    </Descriptions.Item>
    <Descriptions.Item label="Обратная связь для руководителя">
      {renderMulti(form.managerFeedback, MANAGER_FEEDBACK, form.managerFeedbackOther)}
    </Descriptions.Item>
    <Descriptions.Item label="Главный результат встречи">
      {renderMulti(form.meetingMainResult, MEETING_MAIN_RESULT, form.meetingMainResultOther)}
    </Descriptions.Item>
    {form.singleTopicPriority && (
      <Descriptions.Item label="Приоритетная тема">
        {form.singleTopicPriority}
      </Descriptions.Item>
    )}
  </Descriptions>
);

export default FormResponseView;
